import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.typesOfSkillsTransversal],
        config: {
            headerName: getLocalizedString("skillsCode"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.typesOfSkillsTransversal],
        config: {
            headerName: getLocalizedString("competencyName"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.typesOfSkillsTransversal],
        config: {
            headerName: getLocalizedString("taskUpdateDate"),
            field: "updateDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.typesOfSkillsTransversal],
        config: {
            headerName: getLocalizedString("competencyDescription"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.typesOfSkillsTransversal],
        config: {
            headerName: getLocalizedString("indicators"),
            field: "indicators",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
]